import { connect } from 'react-redux';
import { styles } from '../dockPadStyle'
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import { dialogActions } from '../../actions/dialog.actions';
import { lookaheadActions } from '../../actions/lookahead.actions'

import { 
    hasStartedPhasePlan,
    getTrades
} from '../../selectors/phaseplan.selector'
import { getProjectId } from '../../selectors/project.selector';
import { ThunkDispatch } from 'redux-thunk';
import { firebaseConnect } from 'react-redux-firebase';
import { withRouter } from "react-router";
import { 
    getSelectedLookaheadId, 
    getSelectedLookahead, 
    getLookaheads, 
    getLookaheadTags, 
    getLookaheadColumnTags,
    getMinLookaheadDate,
    getMaxLookaheadDate, 
    getLookaheadMilestones,
    getSelectedLookaheadTags,
    getLookaheadConstraints,
    getLookaheadTradesList,
    lookaheadTagFBConnect,
    hasCommitment,
    getTradeFilter,
    isLookaheadHistogramOpen, 
    getLookaheadCommitmentList, isLockedDown, getLookaheadNames, getMilestoneKeys, getLookaheadOffDays, getLookaheadName, getClosedRowGroups, getRowGroups, getGroupBounds, getLookaheadTrades
} from '../../selectors/lookahead.selector';
import LookaheadScreen from '../../components/Lookahead/LookaheadScreen';
import { isSelectMultiPressed } from '../../selectors/util.selector';
import { uiActions } from '../../actions/ui.actions';
import { TagsChangesInterface } from '../../actions/phaseplan.actions';
import { SelectedTag } from '../../models/ TagType';
import { Point } from '../../modules/ui.reducer';
import { getCopiedLookaheadTagsCount, isDialogOpen } from '../../selectors/dialog.selector';
import { homeActions } from '../../actions/home.actions';
import { Trade } from '../../models/Trade';
import { ColumnType } from '../../components/PhasePlan/Column';
import { isAdmin } from '../../selectors/user.selector';
import { getUserTrades } from '../../selectors/trade.selector';


const mapStateToProps = (state:any) => ({
    trades:  getLookaheadTrades(state),
    projectId: getProjectId(state),
    lookaheadNames: getLookaheadNames(state),
    selectedLookaheadId: getSelectedLookaheadId(state),
    hasStartedPhasePlan: hasStartedPhasePlan(state),
    minLookaheadDate: getMinLookaheadDate(state),
    maxLookaheadDate: getMaxLookaheadDate(state),
    milestones: getLookaheadMilestones(state),
    selectedTagsSet: getSelectedLookaheadTags(state),
    isSelectMultPressed: isSelectMultiPressed(state),
    constraints: getLookaheadConstraints(state),
    copiedTagsCount: getCopiedLookaheadTagsCount(state),
    hasCommitment: hasCommitment(state),
    tradeFilter: getTradeFilter(state), 
    _isHistogramOpen: isLookaheadHistogramOpen(state),
    isDialogOpen: isDialogOpen(state),
    isLockedDown: isLockedDown(state),
    milestoneKeys: getMilestoneKeys(state),
    lookaheadOffDays: getLookaheadOffDays(state),
    lookaheadName: getLookaheadName(state),
    closedRowGroups: getClosedRowGroups(state),
    rowGroups: getRowGroups(state),
    groupBounds: getGroupBounds(state),
    isAdmin: isAdmin(state),
    userTrades: getUserTrades(state)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        undoTag: () => dispatch(lookaheadActions.undoTag()),
        clearUndoCommands: () => dispatch(lookaheadActions.onClearUndoCommand()),
        unselectAllSelectTags: () => dispatch(lookaheadActions.lookaheadSelectedTagsClearActionAsync()),
        deleteLookaheadTagColumn: (changes: TagsChangesInterface) => dispatch(lookaheadActions.deleteTagColumn(changes)),
        selectNewLookahead: (lookaheadKey:string) => dispatch(lookaheadActions.lookaheadSelected(lookaheadKey)),
        changeLookaheadTagColumn: (changes: TagsChangesInterface) => 
        dispatch(lookaheadActions.changeLookaheadTagColumn(changes)),
        showLookaheadTagDialogValue: (tagId:string) => dispatch(lookaheadActions.lookaheadDialogOpen(tagId)),
        closeTagDialogValue: () => dispatch(lookaheadActions.lookaheadDialogClose()),
        showTradeDialogValue: (tradeId:string | null) => dispatch(dialogActions.showTradeDialog(tradeId)),
        tagSelected: (tags: Record<string, SelectedTag>) => dispatch(lookaheadActions.lookaheadTagsSelectedActionAsync(tags)),
        tagsClear: () => dispatch(lookaheadActions.lookaheadSelectedTagsClearActionAsync()),
        openHelpDialog: () => dispatch(dialogActions.openHelpInfoDialog()),
        columnClear: () => dispatch(uiActions.columnClearAsync()),
        openConstraintDialog: (constaintId?: string) => dispatch(dialogActions.openConstraintDialog(constaintId)),
        clearPendingDragUpdates: () => dispatch(uiActions.clearPendingDragUpdatesAsync()),
        showPendingDragUpdates: (tagId:string,  newPoint:Point, oldPoint:Point) => dispatch(uiActions.showPendingDragUpdatesAsync(tagId, newPoint, oldPoint)),
        showConstraintLogDialog: () => dispatch(dialogActions.openConstraintLogDialog()),
        openCommitTagDialog: () => dispatch(dialogActions.openCommitDialog()),
        openVarianceLogDialog: () => dispatch(dialogActions.openVarianceLogDialog()),
        openEndCommitDialog: () => dispatch(dialogActions.openEndCommitmentDialog()),
        filterTagsByTrade: (trade: Trade | null) => dispatch(lookaheadActions.makeReadyPlanFilterByTrade(trade)),
        openTaskFilesDialog: () => dispatch(homeActions.openTaskFilesDialog()),
        lockDownPlan: () => dispatch(lookaheadActions.lockDownPlan()),
        openDeleteTagDialog: ( tags:Record<string, SelectedTag>, type:ColumnType ) => dispatch(dialogActions.showDeleteTagDialog(tags, type)),
        openPrintBoardDialog: () => dispatch(dialogActions.openPrintBoardDialog()),
        updateZoom: (zoom: number) => dispatch(uiActions.setUpdateZoomAsync(zoom)),
    scrollCheck: (left:number, top:number, width:number, height:number, screenWidth:number, screenHeight: number) => dispatch(lookaheadActions.scrollCheck(left, top, width, height, screenWidth, screenHeight))
    }
};



export default compose<React.ComponentClass>(
    connect(state => {
        return {
            projectId: getProjectId(state),
            lookaheadId: getSelectedLookaheadId(state)
        };
    }),
    firebaseConnect(lookaheadTagFBConnect),
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles, { withTheme: true }),
    
)(LookaheadScreen)



// WEBPACK FOOTER //
// ./src/containers/Lookahead/LookaheadContainer.ts